import * as DialogPrimitive from "@radix-ui/react-dialog";
import type { ComponentProps } from "react";

export const DialogPortal = ({ ...props }: ComponentProps<typeof DialogPrimitive.Portal>) => {
  return <DialogPrimitive.Portal data-slot="dialog-portal" {...props} />;
};
